import { useState, memo, useCallback } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  TextField,
  Alert,
} from '@mui/material';
import { validatePassword } from '../../../util/validation';

const PasswordDialog = memo(function PasswordDialog({
  open,
  onClose,
  onSave,
  title = 'Passwort ändern',
}) {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errors, setErrors] = useState([]);

  const handleClose = useCallback(() => {
    setPassword('');
    setConfirmPassword('');
    setErrors([]);
    onClose();
  }, [onClose]);

  const handleSave = useCallback(() => {
    const validation = validatePassword(password, confirmPassword);
    if (validation.isValid) {
      onSave(password);
      handleClose();
    } else {
      setErrors(validation.errors);
    }
  }, [password, confirmPassword, onSave, handleClose]);

  if (!open) return null;

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 2 }}>
          <TextField
            fullWidth
            label='Neues Passwort'
            type='password'
            value={password}
            onChange={e => setPassword(e.target.value)}
          />
          <TextField
            fullWidth
            label='Passwort wiederholen'
            type='password'
            value={confirmPassword}
            onChange={e => setConfirmPassword(e.target.value)}
          />
          {errors.length > 0 && (
            <Alert severity='error'>
              {errors.map((error, index) => (
                <div key={index}>{error}</div>
              ))}
            </Alert>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Abbrechen</Button>
        <Button onClick={handleSave} variant='contained' color='primary'>
          Speichern
        </Button>
      </DialogActions>
    </Dialog>
  );
});

export default PasswordDialog;
